import React, { useEffect, createElement } from 'react';
import AdvertorialEMFInvestigation from '../components/Advertorial-EMF-Investigation';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function EMFInvestigation() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID
    window.fbq('init', '2530845004033567');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'EMF Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-3647">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-3648">
        <Helmet data-id="element-3649">
          <title data-id="element-3650">
            Nurse Practitioner Investigates: Do EMF 'Protection' Stickers
            Actually Work?
          </title>
          <meta property="og:title" content="Nurse Practitioner Investigates: Do EMF 'Protection' Stickers Actually Work?" data-id="element-3651" />
          <meta property="og:description" content="After 26 years in medicine, I've seen every 'miracle cure' come and go. So when I found out about 'EMF protection' stickers, I decided to run an 8-month investigation." data-id="element-3652" />
          <meta property="og:type" content="article" data-id="element-3653" />
          <meta property="og:url" content={window.location.href} data-id="element-3654" />
          <meta property="og:image:width" content="1200" data-id="element-3655" />
          <meta property="og:image:height" content="630" data-id="element-3656" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-3657" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-3658" />
          <meta name="twitter:title" content="Nurse Practitioner Investigates: Do EMF 'Protection' Stickers Actually Work?" data-id="element-3659" />
          <meta name="twitter:description" content="After 26 years in medicine, I've seen every 'miracle cure' come and go. So when I found out about 'EMF protection' stickers, I decided to run an 8-month investigation." data-id="element-3660" />
          <meta name="twitter:url" content={window.location.href} data-id="element-3661" />
        </Helmet>
        <AdvertorialEMFInvestigation data-id="element-3662" />
      </div>
    </HelmetProvider>;
}